module.exports = __webpack_public_path__ + "img/smart_logs_paper_making.cf2f7491.svg";